/* eslint-disable parog-web/no-glint-expect-error-directive */
import BaseMedicalHistoryFormComponent from 'parog-web/components/medical-history/abstract/base-edition-form';
import MedicalHistoryBaseEditionForm from './base-edition-form';

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  override journalEventProperties = [...this.sharedProperties];

  <template>
    <MedicalHistoryBaseEditionForm
      {{! @glint-expect-error }}
      @forcComponent={{this}}
      @patient={{@patient}}
      as |mh|
    >
      <mh.FurSection />
      <mh.ComorbiditiesAllergiesSection />
      <mh.VaccinesSection />
      <mh.CommentsSection />
    </MedicalHistoryBaseEditionForm>
  </template>
}
